/* istanbul ignore file */
import type { ComponentProps } from 'react';

import { useIsSunriseTheme } from '@change-corgi/design-system-legacy/theme';

import { StepActions as StepActionsSunrise } from './StepActions';
import { StepActions as StepActionsLegacy } from './StepActionsLegacy';

export const StepActions = (props: ComponentProps<typeof StepActionsLegacy>) => {
	const isSunriseThemeEnabled = useIsSunriseTheme();

	if (isSunriseThemeEnabled) return <StepActionsSunrise {...props} />;

	return <StepActionsLegacy {...props} />;
};
